import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoaderService} from '../shared/services/util/loader.service';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class LayoutComponent implements OnInit {

  constructor(private router: Router,
              private loaderService: LoaderService) {
    this.loaderNavigation();
  }

  ngOnInit() {
  }

  loaderNavigation() {
    this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loaderService.show();
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loaderService.hide();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

}
